import { z } from 'zod';

/**
 * Schema for adding co-vendor
 */
export const addCoVendorSchema = z.object({
  name: z
    .string()
    .min(1, 'Vendor name is required')
    .min(2, 'Vendor name must be at least 2 characters')
    .max(100, 'Vendor name must be less than 100 characters')
    .trim(),
  email: z
    .string()
    .trim()
    .toLowerCase()
    .refine(
      (val) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(val);
      },
      {
        message: 'Please enter a valid email address',
      },
    ),
  countryCode: z
    .string()
    .min(1, 'Country code is required')
    .regex(/^\+\d+$/, 'Invalid country code format'),
  phone: z
    .string()
    .min(1, 'Contact number is required')
    .regex(/^\d+$/, 'Contact number must contain only digits')
    .min(8, 'Contact number must be at least 8 digits')
    .max(15, 'Contact number must be less than 15 digits'),
});

export type AddCoVendorFormData = z.infer<typeof addCoVendorSchema>;

